import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addParameterSwitching from "./components/addParameterSwitching";
export default {
  name: "loginParameterSwitching",
  mixins: [loadMoreList, commonData],
  components: {
    addParameterSwitching: addParameterSwitching
  },
  data: function data() {
    return {
      pagingReqFn: "appLoginReplaceListData",
      delIds: [],
      paramsData: {
        isMustAppid: 2
      }
    };
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getcommonData(['appListAllData']);

              _this.getList();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'appLoginReplaceListDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this2.getList(_this2.paramsData.page);
      });
    }
  }
};